import { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { LoadingPlaceholder } from "../../components/LoadingPlaceholder";
import { OptVerification } from "../../components/OptVerification";
import { ModalPayoutAccounts } from "../../shared/components/ModalPayoutAccounts";
import { MemberPlaidModals } from "../../utils/usePlaidLink";
import { EmbeddedError } from "./components/EmbeddedError";
import { useInitEmbeddedApp } from "./hooks/useInitEmbeddedApp";
import {
  PATH_EMBEDDED_DEFAULT_PAYMENT_METHOD,
  PATH_EMBEDDED_DEFAULT_PAYOUT_METHOD,
  PATH_EMBEDDED_MANAGE_FUNDING_METHOD,
  PATH_EMBEDDED_MANAGE_PAYMENT_METHOD,
  PATH_EMBEDDED_MANAGE_PAYOUT_METHOD,
  PATH_EMBEDDED_ONBOARDING,
  PATH_EMBEDDED_PREVIEW_FUNDING_METHOD
} from "./paths";
import { RouteDefaultPaymentMethod } from "./routes/RouteDefaultPaymentMethod";
import { RouteDefaultPayoutMethod } from "./routes/RouteDefaultPayoutMethod";
import { RouteManageFundingMethod } from "./routes/RouteManageFundingMethod";
import { RouteManagePaymentMethod } from "./routes/RouteManagePaymentMethod";
import { RouteManagePayoutMethod } from "./routes/RouteManagePayoutMethod";
import { RouteOnboarding } from "./routes/RouteOnboarding";
import { RoutePreviewFundingMethod } from "./routes/RoutePreviewFundingMethod";

export const Embedded = () => {
  const [initEmbeddedApp, initEmbeddedAppMeta] = useInitEmbeddedApp();

  useEffect(() => {
    initEmbeddedApp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (initEmbeddedAppMeta.isLoading || initEmbeddedAppMeta.isIdle) {
    return <LoadingPlaceholder blank />;
  }

  if (initEmbeddedAppMeta.isError) {
    return <EmbeddedError message="Failed to initialize embedded app" />;
  }

  return (
    <>
      <Switch>
        <Route component={RouteOnboarding} path={PATH_EMBEDDED_ONBOARDING} />
        <Route
          component={RouteDefaultPaymentMethod}
          path={PATH_EMBEDDED_DEFAULT_PAYMENT_METHOD}
        />
        <Route
          component={RouteDefaultPayoutMethod}
          path={PATH_EMBEDDED_DEFAULT_PAYOUT_METHOD}
        />
        <Route
          component={RouteManagePayoutMethod}
          path={PATH_EMBEDDED_MANAGE_PAYOUT_METHOD}
        />
        <Route
          component={RouteManagePaymentMethod}
          path={PATH_EMBEDDED_MANAGE_PAYMENT_METHOD}
        />
        <Route
          component={RouteManageFundingMethod}
          path={PATH_EMBEDDED_MANAGE_FUNDING_METHOD}
        />
        <Route
          component={RoutePreviewFundingMethod}
          path={PATH_EMBEDDED_PREVIEW_FUNDING_METHOD}
        />

        <Route render={() => <EmbeddedError message="Unknown route" />} />
      </Switch>

      <MemberPlaidModals />
      <OptVerification />
      <ModalPayoutAccounts />
    </>
  );
};
